import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} Anonymous-Chat Home`,
    languageButtonLabel: `Sprache`,
    languageModalTitle: `Sprache wähle`,
    languageModalCloseLabel: `Sprachmenü schliesse`,
  },
  languageOptions: {
    'en-US': {
      label: `Englisch (Vereinigte Staaten)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Englisch (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Englisch (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Englisch (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugiesisch (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugiesisch (Brasilien)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Deutsch (Deutschland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanisch (Spanien)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Französisch (Frankreich)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italienisch (Italien)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Niederländisch (Niederlande)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polnisch (Polen)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Schwedisch (Schweden)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dänisch (Dänemark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finnisch (Finnland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norwegisch (Norwegen)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Isländisch (Island)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanisch (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreanisch (Südkorea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chinesisch (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesisch (Sonderverwaltungsregion Hongkong)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamesisch (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thailändisch (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesisch (Indonesien)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Suaheli (Kenia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Indien)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalisch (Bangladesch)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (Indien)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Indien)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persisch (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigerianisches Pidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisch (Russland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisch (Saudi-Arabien)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabisch (Vereinigte Arabische Emirate)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabisch (Katar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkanisches Arabisch (Marokko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkisch (Türkei)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Sprache wähle`,
    closeLabel: `Sprachmenü schliesse`,
  },
  languageHint: (ctx) => `Spring über ${ctx.localesCount}+ Sprachversione ohni Account.`,
  readPagePrompt: ({languageLabel}) => `Lies die Site uf ${languageLabel}.`,
};
